import * as React from 'react';

import cx from 'classnames';

import { QuizAnswer } from '../../models/quizzes';
import ChoiceLabel from './ChoiceLabels';
import ContentOrFields from './ContentOrFields';

interface Props {
  answer: QuizAnswer;
  answerPlaceholder: string;
  isFirst: boolean;
  isEditing: boolean;
  isDisabled: boolean;
}

/**
 * Displays Question elements relevant to a Multiple Choice question.
 */
const MultipleChoiceAnswers = ({
  answer,
  answerPlaceholder,
  isFirst,
  isEditing,
  isDisabled,
}: React.PropsWithChildren<Props>) => {
  const itemClass = cx(
    'grid grid-cols-question-fields-question-editor max-w-5xl p-0 flex-1',
    {
      'mt-4': isEditing || isFirst,
    }
  );
  return (
    <div className={itemClass} data-answer-choice>
      <div className="flex items-center justify-center col-start-2 w-12 h-12 ">
        <ChoiceLabel isCorrect={answer.isCorrect} />
      </div>
      <ContentOrFields
        answerPlaceholder={answerPlaceholder}
        answer={answer}
        isEditing={isEditing}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default MultipleChoiceAnswers;
